/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/KlondikeGameMode',[
        'Solitaire/GameModes/GameModeBase',
        'Solitaire/GameModes/IGameMode',
        'Solitaire/SolitaireGameMode',
        'SolitaireShared/KlondikeTemplate/KlondikeWindowsTemplate',
        'Solitaire/GameResult',
        'Solitaire/GameState',
        'Solitaire/SolitaireStatistics'
    ],
function (GameModeBase, IGameMode, SolitaireGameMode, KlondikeWindowsTemplate, GameResult, GameState, SolitaireStatistics) {
    "use strict";

    var KlondikeGameMode = function () {
        this.initKlondikeGameMode();
    };

    KlondikeGameMode.constructor = KlondikeGameMode;
    KlondikeGameMode.prototype = Object.create(GameModeBase.prototype);
    IGameMode.call(KlondikeGameMode.prototype);

    KlondikeGameMode.prototype.initKlondikeGameMode = function () {
        this.Name = SolitaireGameMode.Klondike;
    };

   Object.defineProperty(KlondikeGameMode.prototype, "TimerOption", {
       get: function ()
       {
           if (GameState.CurrentGame.Authority.IsChallenge) {
               return GameState.CurrentGame.Authority.TimerEnabled ? IGameMode.TimerSettings.CountDown : IGameMode.TimerSettings.Off;
           }

           var value = GameState.CurrentGame.Authority.CardSupply.GetOption("KlondikeTimer") === "true";
           return value ? IGameMode.TimerSettings.CountUp : IGameMode.TimerSettings.Off;
       }
   });

    KlondikeGameMode.prototype.ConfigureSolitairePage = function (page) {
        // TODO where is Supply defined?
        //Supply.UseCumulativeScoring = (GameState.CurrentGame.Authority.CardSupply.GetOption("Scoring") == "LASVEGASCUMULATIVE");
    };

    KlondikeGameMode.prototype.CreateTemplate = function () {
        return new KlondikeWindowsTemplate();
    };


    KlondikeGameMode.prototype.GetCheatMoves = function () {
        return "G KLONDIKE O DRAW 1 O SCORING STANDARD D 55712977639165545899751645785150140100232475048673821137333482906379 [3801] B M 11 4 1 M 10 11 1 E [4360] M 2 3 -1 [6245] B M 17 11 1 M 16 17 1 E [9675] M 2 3 -1 [11488] B M 19 21 1 M 18 19 1 E [12573] B M 19 5 1 M 18 19 1 E [14053] U 1 [14345] U 1 [14754] U 1 [15757] B M 19 21 1 M 18 19 1 E [16683] B M 19 5 1 M 18 19 1 E [17865] M 3 5 1 [19475] M 2 3 -1 [21009] M 2 3 -1 [23076] M 2 3 -1 [25472] M 2 3 -1 [27776] M 2 3 -1 [29225] M 2 3 -1 [30511] M 3 5 1 [30856] M 2 3 -1 [32629] M 2 3 -1 [34755] M 2 3 -1 [36376] M 3 13 1 [37263] M 11 13 2 [39950] B M 17 11 1 M 16 17 1 E [42528] B M 21 17 2 M 20 21 1 E [44201] B M 21 11 1 M 20 21 1 E [47437] M 9 21 1 [48420] B M 21 13 2 M 20 21 1 E [50281] B M 21 9 1 M 20 21 1 E [54489] M 2 3 -1 [56414] M 3 11 1 [57035] M 2 3 -1 [58200] U 1 [58447] U 1 [59348] B M 13 11 6 M 12 13 1 E [60843] B M 13 19 1 M 12 13 1 E [65379] M 2 3 -1 [66665] M 2 3 -1 [68301] M 3 19 1 [69010] M 2 3 -1 [70724] M 3 4 1 [71894] M 2 3 -1 [73742] M 3 4 1 [74451] M 2 3 -1 [76318] M 2 3 -1 [77314] M 3 6 1 [77839] M 2 3 -1 [79137] M 2 3 -1 [80952] M 2 3 -1 [82489] M 3 15 1 [83253] M 2 3 -1 [85227] M 3 21 1 [86132] M 2 3 -1 [88657] M 2 3 -1 [91368] M 2 3 -1 [92743] M 3 2 -15 [93064] M 2 3 -1 [95566] M 2 3 -1 [96878] M 2 3 -1 [98800] M 3 19 1 [102689] M 2 3 -1 [103934] M 3 6 1 [105511] M 2 3 -1 [107201] M 3 15 1 [108036] M 2 3 -1 [109709] M 3 9 1 [110974] B M 15 9 3 M 14 15 1 E [115739] B M 17 15 3 M 16 17 1 E [122097] B M 15 11 4 M 14 15 1 E [128129] M 2 3 -1 [130292] M 2 3 -1 [132616] M 2 3 -1 [133670] M 2 3 -1 [137966] B M 19 9 4 M 18 19 1 E [142381] M 2 3 -1 [143671] M 2 3 -1 [145745] M 2 3 -1 [149851] M 3 19 1 [151031] M 13 19 1 [151653] M 2 3 -1 [153732] M 2 3 -1 [155208] M 3 15 1 [156464] B M 21 15 2 M 20 21 1 E [157746] B M 21 13 1 M 20 21 1 E [159084] B M 17 13 1 M 16 17 1 E [166999] M 3 2 -9 [167425] M 2 3 -1 [169254] M 3 5 1 [169630] M 2 3 -1 [176748] M 3 17 1 [177692] M 2 3 -1 [179622] M 3 21 1 [181415] M 2 3 -1 [183282] M 2 3 -1 [184492] M 2 3 -1 [192484] M 2 3 -1 [194157] M 2 3 -1 [196085] M 3 21 1 [196870] M 2 3 -1 [198294] M 3 21 1 [200222] M 3 2 -4 [200592] M 2 3 -1 [201108] M 2 3 -1 [201868] M 2 3 -1 [203126] M 3 21 1 [203977] B M 19 21 3 M 18 19 1 E [206195] B M 19 13 1 M 18 19 1 E [211269] M 17 19 2 [215803] M 3 17 1 [216392] M 2 3 -1 [217420] M 3 17 1 [218731] M 3 17 1 [219484] B M 15 17 4 M 14 15 1 E [220526] M 15 7 1 [231639] M 11 7 1 [235499] M 11 6 1 [236756] M 11 4 1 [238518] M 21 7 1 [241093] M 19 7 1 [244045] M 21 6 1 [244636] M 19 6 1 [245291] M 21 4 1 [246584] M 11 5 1 [247156] M 9 7 1 [247636] M 9 5 1 [248087] M 11 4 1 [249057] M 19 7 1 [249596] M 21 6 1 [251178] M 21 13 4 [252332] M 17 15 7 [253053] M 15 5 1 [253479] M 13 4 1 [253971] M 11 6 1 [254465] M 9 7 1 [254843] M 9 5 1 [255326] M 11 4 1 [255753] M 13 6 1 [256172] M 15 7 1 [256564] M 15 5 1 [257012] M 13 7 1 [257473] M 11 6 1 [257920] M 9 4 1 [258302] M 9 5 1 [258755] M 11 7 1 [259185] M 13 6 1 [259615] M 15 4 1 [260031] M 15 5 1 [260452] M 13 4 1 [260933] M 11 6 1 [261412] M 9 7 1 [261831] M 9 5 1 [262283] M 11 4 1 [262742] M 13 6 1 [263223] M 15 7 1 [264022] N";
    };

    KlondikeGameMode.prototype.HelpDataSource = function () {
        throw "TODO"; // TODO
        return null;
        //return SimpleIoc.Default.GetInstance<MvvmStructure.Model.KlondikeHelpDataSource>();
    };


    KlondikeGameMode.prototype.GetGameEnd = function () {
        throw "TODO";
        return null;
        /*var model = new GameEndModel
        {
            LockIconSourcePath = "Assets/ui/icons/update.png",
        };

        model.AddStatValue("ScoreText", LocalizationManager.GetString("YouScoredColon_Title/Text"), GameEndTileTemplates.Highlighted);
        model.AddStatValue("TimeBonus", LocalizationManager.GetString("gameEndResultTimeBonus"), GameEndTileTemplates.Highlighted);
        model.AddStatValue("TotalScore", LocalizationManager.GetCommonLocalizedString("gameEndResultTotalScore"), GameEndTileTemplates.Highlighted);
        model.AddStatValue("HighScore", LocalizationManager.GetString("HighScore_Title/Text"), GameEndTileTemplates.Highlighted);
        model.AddStatValue("Time", LocalizationManager.GetString("Time_Title/Text"));
        model.AddStatValue("BestTime", LocalizationManager.GetString("BestTime_Title/Text"));
        model.AddStatValue("GamesPlayed", LocalizationManager.GetString("GamesPlayed_Title/Text"));
        model.AddStatValue("GamesWon", LocalizationManager.GetString("GamesWon_Title/Text"));
        model.AddStatValue("WinPercentage", LocalizationManager.GetString("WinPercentage_Title/Text"));
        *//* model.AddStatValue("CurrentStreak", LocalizationManager.GetString("CurrentStreak_Title/Text"));
         model.AddStatValue("LongestWinningStreak", LocalizationManager.GetString("LongestWinningStreak_Title/Text"));
         model.AddStatValue("LongestLosingStreak", LocalizationManager.GetString("LongestLosingStreak_Title/Text"));*//*
        model.Optional1ButtonText = LocalizationManager.GetString("OptionalButton_TryAgain");
        model.Optional1Visibility = Visibility.Visible;
        SetDefaults(model);
        model.UpdateStatistics = UpdateStatistics;

        return model;*/
    };

    KlondikeGameMode.prototype.SetShare = function (args) {
        // TODO
        /*var description = new StringBuilder();
        var message = new StringBuilder();
        string gameTitle = LocalizationManager.GetLocalizedString("SolitaireCollection_Title/Text");
        description.Append(LocalizationManager.GetString(string.Format("Share_Description_{0}", Name.ToString())));
        message.Append(LocalizationManager.GetString(string.Format("Share_Description_{0}", Name.ToString())));
        message.Replace("%GAME_TITLE%", gameTitle).Replace("%SCORE%",SolitaireStatistics.Current.GetScoreFormatString(GetStatKey()));
        ShareManager.SetShareMessage(args, gameTitle, description, message);*/
    };

    KlondikeGameMode.GetStatKeyStatic = function () {
        // TODO
        return new SolitaireStatistics.StatKey(
            GameState.CurrentGame.ActiveMode.Name,
            (GameState.CurrentGame.GetOption("DRAW") + GameState.CurrentGame.GetOption("SCORING") + SolitaireGameMode.getModeById(GameState.CurrentGame.ActiveMode.Name)).toUpperCase());
    };

    KlondikeGameMode.prototype.GetStatKey = function () {
        return KlondikeGameMode.GetStatKeyStatic();
    };

    KlondikeGameMode.prototype.UpdateStatistics = function (model) {
        //if (GameState.CurrentGame.ActiveMode.Name == SolitaireGameMode.Unknown) return;

        var statkey = KlondikeGameMode.GetStatKeyStatic();

        var currentScore = SolitaireStatistics.Current.GetScore(statkey);
        var bonusScore = GameState.CurrentGame.Authority.GetBonusScore(GameState.CurrentGame.Authority.CardSupply.TimePlayed);
        var scoreWithoutBonus = 0;

        if (GameState.CurrentGame.GameResult == GameResult.Win)
        {
            //User Won here so update stats and save them to disk
            SolitaireStatistics.Current.UpdateGameWon(statkey);
            //model.Optional1ButtonText = "";
            //model.Optional1Visibility = Visibility.Collapsed;
            scoreWithoutBonus = currentScore - bonusScore;
        }
        else if (GameState.Current == GameState.GameComplete)
        {
            //model.Optional1ButtonText = LocalizationManager.GetString("OptionalButton_TryAgain");
            //User Lost here so update stats and save them to disk
            SolitaireStatistics.Current.UpdateGameLost(statkey);
            //model.Optional1Visibility = Visibility.Visible;
            scoreWithoutBonus = currentScore;
            bonusScore = 0;
        }

        //Update GameEnd Model with Latest Stats
        model["ScoreText"] =  SolitaireStatistics.Current.GetStringFormat(scoreWithoutBonus);
        model["TimeBonus"] = SolitaireStatistics.Current.GetStringFormat(bonusScore);
        model["TotalScore"] = SolitaireStatistics.Current.GetScoreFormatString(statkey);
        model["Time"] = SolitaireStatistics.Current.GetTimeFormatString(statkey);
        model["HighScore"] = SolitaireStatistics.Current.GetHighScoreFormatString(statkey);
        model["BestTime"] = SolitaireStatistics.Current.GetBestTimeFormatString(statkey);
        model["GamesPlayed"] = SolitaireStatistics.Current.GetGamesPlayedFormatString(statkey);
        model["GamesWon"] = SolitaireStatistics.Current.GetGamesWonFormatString(statkey);
        model["WinPercentage"] = SolitaireStatistics.Current.GetPercentWon(statkey);
        //model["LongestWinningStreak"] = SolitaireStatistics.Current.GetLongestWinningStreakFormatString(new SolitaireStatistics.StatKey(GameState.CurrentGame.ActiveMode.Name, "+TOTALKLONDIKE"));


        /*model.UpdateStatValue("CurrentStreak", SolitaireStatistics.Current.GetWinningStreakFormatString(statkey));
         model.UpdateStatValue("LongestWinningStreak", SolitaireStatistics.Current.GetLongestWinningStreakFormatString(statkey));
         model.UpdateStatValue("LongestLosingStreak", SolitaireStatistics.Current.GetLongestLosingStreakFormatString(statkey));*/

        //UpdateLiveTile();
    };

    KlondikeGameMode.prototype.UpdateLeaderBoard = function ()
    {
        // XBox live is unsupported
        /*var stats = SolitaireStatistics.Current;
        var statkey = GetStatKeyStatic();
        if ( App.CurrentApp.GameNetClient.Settings.XblConnected)
        {
            // high score
            uint lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.HIGHSCORE];
            await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore(stats.GetHighScore(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);

            //lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.key + SolitaireLeaderboards.LONGESTWINNINGSTREAK];
            //result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetLongestWinningStreak(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Replace);
        }*/
    };

    return KlondikeGameMode;

});

